import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommAmphoraFillIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.817 18.3053C14.755 16.7066 16.9992 15.0418 17 11.3644C17.0007 8.64362 14.9846 7.24981 14.3922 6.92335C14.2924 6.86872 14.229 6.76157 14.2283 6.64429C14.2268 6.34193 14.2231 5.77065 14.226 5.37861C14.2268 5.32479 14.2654 5.2781 14.3186 5.26936C15.3926 5.0872 16.1147 4.74839 16.1147 4.36077V3.05071C16.1147 2.46999 14.4964 2.00004 12.4999 2.00004C10.5035 2.00004 8.88519 2.46999 8.88519 3.05071V4.36077C8.88519 4.74839 9.6073 5.0872 10.6813 5.26936C10.7345 5.2781 10.7732 5.32479 10.7739 5.37861C10.7768 5.77065 10.7732 6.34193 10.7716 6.64429C10.7709 6.76157 10.7076 6.86872 10.6078 6.92335C10.0153 7.24981 7.9992 8.64362 8 11.3644C8.0007 15.0418 10.2449 16.7066 10.1829 18.3053C10.1567 18.9909 9.50095 20.3826 9.18102 21.2402C9.04405 21.6074 9.06885 22.0613 9.65901 22.3368C10.2593 22.611 11.3643 22.8354 12.4999 22.8354C13.6356 22.8354 14.7407 22.611 15.3409 22.3368C15.931 22.0613 15.9558 21.6074 15.8189 21.2402C15.499 20.3826 14.8432 18.9909 14.817 18.3053Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
